import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{
      background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a3e 50%, #0f0f23 100%)'
    }}>
      <Card className="max-w-md w-full glass-effect border-cyan-500/30">
        <CardHeader className="text-center">
          <XCircle className="w-16 h-16 mx-auto text-gray-400 mb-4" />
          <CardTitle className="text-2xl text-white">
            Payment Cancelled
          </CardTitle>
        </CardHeader>
        
        <CardContent className="space-y-4 text-center">
          <p className="text-gray-300">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          
          <p className="text-gray-400 text-sm">
            If you have any questions or need assistance, please contact our support team.
          </p>
          
          <div className="flex flex-col gap-2">
            <Button 
              onClick={() => navigate(-1)} 
              className="w-full btn-primary"
            >
              Try Again
            </Button>
            <Button 
              onClick={() => navigate('/dashboard')} 
              variant="outline"
              className="w-full"
            >
              Return to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancelPage;
